export default {
	namespaced: true,
	actions: {
		trackEvent(context, event) {
			// eslint-disable-next-line
			this._vm.$gtag.event(event);
		},
		trackPageView(context, page) {
			const view = { ...page, documentReferrer: document.referrer };
			// eslint-disable-next-line
			this._vm.$gtag.pageview(view);
		},
		trackEndgameEvents({ dispatch, rootState }) {
			const eventCategory = "EndGame";
			dispatch("trackEvent", { eventCategory, el: "GameOutcome", ea: rootState.game.outcome });
			dispatch("trackEvent", { eventCategory, el: "WinningCash", ea: rootState.game.balance.amount });
		},
	},
};
